import {Component, Inject, OnInit, signal} from '@angular/core';

import { Router, RouterModule } from "@angular/router";
import {NGXLogger} from 'ngx-logger';
import { AvatarModule } from "ngx-avatars";
import { User, ENVIRONMENT } from '@company-box/models';
import { UserService, AlertService } from '@company-box/services';
import { MobileSidebarToggleDirective } from "@company-box/utils";

@Component({
  selector: "app-header",
  standalone: true,
  templateUrl: "./app-header.component.html",
  imports: [RouterModule, AvatarModule, MobileSidebarToggleDirective],
})

export class AppHeaderComponent implements OnInit {
  public user: User | undefined;
  logo = signal<string>(`url(${this.environment.logos.large})`);

  constructor(
    private router: Router,
    private userService: UserService,
    private logger: NGXLogger,
    private alertSvc: AlertService,
    @Inject(ENVIRONMENT) private environment: any
  ) {
  }

  ngOnInit(): void {
    if (!!localStorage.getItem('menu.minimized')) {
        this.logo.set(`url(${this.environment.logos.small})`);
    } else {
      this.logo.set(`url(${this.environment.logos.large})`);
    }
    this.userService.getCurrentUser().then((user) => {
      this.user = user;
    });
  }

  public logout(): void {
    this.userService.logout().then(
      () => {
          this.logger.info("redirecting to /login");
          this.router.navigate(["/login"]);
      },
      () => {
        this.alertSvc.showWarning({msg: "Something went wrong while logging out", timeout: 10000});
      }
    );
  }
}
